import * as type from '../types/contact-lists'

export const retrieveAllContactLists = payload => {
    return{
        type: type.REQUEST_CONTACT_LISTS_CONTENT,
        payload: payload
    }
}

export const resetAllContactLists = () => {
    return{
        type: type.RESET_CONTACT_LISTS_CONTENT
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_CONTACT_LISTS_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_CONTACT_LISTS_DELETION_ARRAY,
        id: payload
    }
}

export const changeContactListsModal = payload => {
    return{
        type: type.CHANGE_CONTACT_LISTS_MODALS,
        modal: payload
    }
}

export const requestAddSingleContactList = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_CONTACT_LIST,
        details: payload
    }
}

export const resetAddSingleContactList = () => {
    return{
        type: type.RESET_ADD_SINGLE_CONTACT_LIST
    }
}

export const setActiveContactListDeletion = payload => {
    return{
        type: type.SET_ACTIVE_CONTACT_LIST_DELETION,
        data: payload
    }
}

export const resetActiveContactListDeletion = payload => {
    return{
        type: type.RESET_ACTIVE_CONTACT_LIST_DELETION
    }
}

export const requestDeleteSingleContactList = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_CONTACT_LIST,
        details: payload
    }
}

export const resetDeleteSingleContactList = () => {
    return{
        type: type.RESET_DELETE_SINGLE_CONTACT_LIST
    }
}

export const requestDeleteContactListsArray = payload => {
    return{
        type: type.REQUEST_DELETE_CONTACT_LIST_ARRAY,
        details: payload
    }
}

export const resetDeleteContactListsArray = () => {
    return{
        type: type.RESET_DELETE_CONTACT_LIST_ARRAY
    }
}

export const setActiveContactListDisplay = payload => {
    return{
        type: type.SET_ACTIVE_CONTACT_LIST_DISPLAY,
        details: payload
    }
}

export const resetActiveContactListDisplay = () => {
    return{
        type: type.RESET_ACTIVE_CONTACT_LIST_DISPLAY
    }
}

export const requestUpdateSingleContactList = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_CONTACT_LIST,
        details: payload
    }
}

export const resetUpdateSingleContactList = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_CONTACT_LIST
    }
}